import { type FC, Suspense } from 'react';
import {
  HeadlinePromoDesktopWidgetContent,
  type IHeadlinePromoDesktopWidgetProps,
} from '@/components/general/Header/DashboardPanel/HeadlinePromoSection/components/HeadlinePromoDesktopWidgetContent';
import { Skeleton } from '@/components/Skeleton';

export const HeadlinePromoDesktopWidget: FC<
  IHeadlinePromoDesktopWidgetProps
> = (props) => (
  <Suspense fallback={<Skeleton.Rect height={48} rounded width={48} />}>
    <HeadlinePromoDesktopWidgetContent {...props} />
  </Suspense>
);
